import http from "../http-common";
import authHeader from "../../services/auth-header";

const getAll = (owner) => {
  if (!owner || owner === "undefined") return Promise.resolve({ data: [] });
  return http.get(`/takaful/${owner}`, { headers: authHeader() });
};

const get = (id) => {
  return http.get(`/takaful/${id}`, { headers: authHeader() });
};

const create = (owner, data) => {
  return http.post(`/takaful/${owner}`, data, { headers: authHeader() });
};

const update = (id, data) => {
  return http.put(`/takaful/${id}`, data, { headers: authHeader() });
};

const remove = (id) => {
  return http.delete(`/takaful/${id}`, { headers: authHeader() });
};

const removeAll = () => {
  return http.delete(`/takaful`, { headers: authHeader() });
};

const findByTitle = (title) => {
  return http.get(`/takaful?title=${title}`, { headers: authHeader() });
};

const TakafulService = {
  getAll,
  get,
  create,
  update,
  remove,
  removeAll,
  findByTitle,
};

export default TakafulService;
